<div class="container-fluid px-0">

  <!-- ================= HEADER ================= -->
  <div class="row">
    <div class="col d-flex">
      <div class="borderline"></div>

      <div class="flex-grow-1 align-self-center mt-2">
        <h5 class="text-dark">
          <strong>Account Info</strong>
        </h5>
      </div>

      <div class="uitk-icon uitk-icon-refresh sm-icon align-self-center mx-2">
       

        <button type="button"
        class="link btn btn-link p-0"
        (click)="refreshAccountTo()"
        appEnableResource="AccounttoRefreshHyperlink">
  Refresh
</button>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <hr class="m-0 bg-dark">
    </div>
  </div>

  <!-- ================= SPINNER ================= -->
  <div *ngIf="isAccountInfoLoading" class="container-fluid py-4">
    <div class="row">
      <div class="col text-center">
        <uitk-loading-indicator
          uitkId="spinner"
          [visibleText]="visibleTextValue"
          spinnerSize="large">
        </uitk-loading-indicator>
      </div>
    </div>
  </div>

  <!-- ================= CONTENT ================= -->
  <div *ngIf="!isAccountInfoLoading">

    <!-- Account Manager -->
    <div class="row px-3">
      <div class="col">
        <div *ngIf="!accountManager">Account Manager: None</div>
        <span *ngIf="accountManager">
          Account Manager :
          <a target="_blank"
             [href]="'mailto:' + accountmanageremail">
            {{ accountManager }}
          </a>
        </span>
      </div>
    </div>

    <!-- Account Owner Manager -->
    <div class="row px-3">
      <div class="col">
        <div *ngIf="!accountManagersupervisor">Account Owner Manager: None</div>
        <span *ngIf="accountManagersupervisor">
          Account Owner Manager :
          <a target="_blank"
             [href]="'mailto:' + accountSupervisorEmail">
            {{ accountManagersupervisor }}
          </a>
        </span>
      </div>
    </div>

    <!-- Software Executive -->
    <div class="row px-3">
      <div class="col">
        <div *ngIf="!softwareexec">Software Executive: None</div>
        <span *ngIf="softwareexec">
          Software Executive :
          <a target="_blank"
             [href]="'mailto:' + softwareExecEmail">
            {{ softwareexec }}
          </a>
        </span>
      </div>
    </div>

    <!-- Data Rep -->
    <div class="row px-3">
      <div class="col">
        <div *ngIf="!datarep">Data Rep: None</div>
        <span *ngIf="datarep">
          Data Rep :
          <a target="_blank"
             [href]="'mailto:' + dataRepEmail">
            {{ datarep }}
          </a>
        </span>
      </div>
  </div>

    <!-- Print Rep -->
    <div class="row px-3">
      <div class="col">
        <div *ngIf="!print">Print Rep: None</div>
        <span *ngIf="print">
          Print Rep :
          <a target="_blank"
             [href]="'mailto:' + printRepEmail">
            {{ print }}
          </a>
        </span>
      </div>
    </div>

    <!-- Print Manager -->
    <div class="row px-3">
      <div class="col">
        <div *ngIf="!printrepManager">Print Manager: None</div>
        <span *ngIf="printrepManager">
          Print Manager :
          <a target="_blank"
             [href]="'mailto:' + printRepManagerEmail">
            {{ printrepManager }}
          </a>
        </span>
      </div>
    </div>

  </div>

</div>